module.exports = "js/webpack/2545e9daa1296aeaf03c8ea0aaab4afe.png";